<template>
  <div>
    <b-row class="ml-0 w-100">
      <b-col md="5" class="pr-0 pie-chart-container">
        <GChart
          :events="chartEvents"
          ref="gChart"
          type="PieChart"
          :data="chartData"
          :options="computedChartOptions"
        />
      </b-col>
      <b-col md="7" class="d-flex flex-column justify-content-center">
        <div class="d-flex flex-column">
          <b-row class="w-100">
            <b-col md="8">
              <h4 class="font-md secondary--text font-family-medium mb-3 mt-4">
                Tasks
              </h4>
            </b-col>
            <b-col md="4">
              <h4 class="font-md secondary--text font-family-medium mb-3 mt-4">
                Duration
              </h4>
            </b-col>
          </b-row>
          <div class="mt-4">
            <b-row
              v-for="(item, index) in taskDetails"
              :key="index"
              class="w-100 d-flex mb-2"
            >
              <b-col md="8" class="flex-row d-flex">
                <b-avatar
                  class="pie-chart-avatar mr-3 mt-1"
                  size="1.5rem"
                  :style="`background: ${item.color}`"
                  text=""
                ></b-avatar>
                <p
                  style="bottom: 0.35rem;"
                  class="primary--text font-weight-normal w-80 position-relative"
                >
                  {{ item.title }}
                </p>
              </b-col>
              <b-col md="4">
                <p
                  style="bottom: 0.35rem"
                  class="primary--text font-weight-normal position-relative"
                >
                  {{ item.duration }}
                </p>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>
    </b-row>
    <!-- <b-row class="mx-0">
      <b-col class="p-0">
        <b-skeleton height="100%" width="100%"></b-skeleton>
      </b-col>
    </b-row> -->
    <!-- <div
      class="no-assigned-msg pr-5 pt-5 pb-5 pl-2 d-flex flex-column justify-content-center align-items-center"
      v-if="noTask"
    >
      <h4 class="primary--text font-family-medium">
        No tasks found.
      </h4>
    </div> -->
  </div>
</template>

<script>
import moment from "moment";
import momentDurationFormatSetup from "moment-duration-format";
momentDurationFormatSetup(moment);

const colors = [
  // Palette 1
  "#FD5C63",
  "#D95388",
  "#E175A0",
  "#E791B3",
  "#8894AA",
  "#9FAABC",
  "#B7C0CC",
  "#CFD5DE",
  // Palette 2
  "#9FCAE2",
  "#80DAEA",
  "#99E1EE",
  "#ADE7F1",
  //
  "#074F89",
  "#0078AA",
  "#3393BB",
  "#5CA9C9"
  // Palette 3
  // Palette 4
];
const chartOptions = {
  tooltip: {
    isHtml: true
  },
  pieSliceText: "none",
  pieStartAngle: 100,
  chartArea: { top: "10%", left: 0, height: "85%", width: "90%" },
  height: 400,
  legend: "none"
};

export default {
  name: "PieChartReport",
  props: {
    categories: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  computed: {
    chartData() {
      let data = this.categories.map(item => {
        return [
          item.title,
          item.totalTime,
          this.getCustomTooltip(item.title, item.totalTime)
        ];
      });
      // adding the headers
      data.unshift([
        "Task Categories",
        "Duration",
        { type: "string", role: "tooltip", p: { html: true } }
      ]);
      return data;
    },
    computedChartOptions() {
      return {
        ...chartOptions,
        colors: colors.slice(0, this.categories.length)
      };
    },
    taskDetails() {
      return this.categories.map((category, index) => {
        return {
          title: category.title,
          duration: this.getDurationInHoursAndMinutes(category.totalTime),
          color: colors[index]
        };
      });
    }
  },
  data() {
    return {
      isLoadingChart: true,
      durationList: [],
      legendTitles: [],
      chartEvents: {}
    };
  },
  methods: {
    getCustomTooltip(title, seconds) {
      const durationInHoursAndMinutes = moment
        .duration(seconds, "seconds")
        .format("hh:mm:ss", {
          trim: false
        });
      return `<h6 class="primary--text font-sm font-family-medium ml-3 py-3">${title}</h6>
          <h6 class="font-sm primary--text font-family-medium ml-3"> ${durationInHoursAndMinutes}</h6>`;
    },
    getDurationInHoursAndMinutes(seconds) {
      const durationInHoursAndMinutes = moment
        .duration(seconds, "seconds")
        .format("hh:mm:ss", {
          trim: false
        });
      return durationInHoursAndMinutes;
    }
  }
};
</script>

<style scoped lang="scss">
.pie-chart-container > div > div > div > div:nth-child(0) {
  pointer-events: none;
}
</style>
